const menu = {
  namespaced: true,
  state: {
    activeRoute: "home",
    routeMap: {
      "双湃智安": "home",
      "安全产品": "product",
      "行业解决方案": "solution",
      "安全服务": "service",
      "π实验室": "lab",
      "可信数据空间":"space",
      "博士后工作站": "doctor",
      "安全态势": "situation",
      "MaaS平台": "maas",
      "关于我们": "about"
    },
    solutionList: [
      {
        id: 1,
        name: "电力",
        subList: [{id: 1, name: "风力发电"}, {id: 2, name: "火力发电"}, {id: 3, name: "水力发电"}, {id: 4, name: "光伏发电"}]
      },
      {
        id: 2,
        name: "石油石化",
        subList: [
          {id: 1, name: "石油炼化"},
          {id: 2, name: "油气开采"}]
      },
      {
        id: 3,
        name: "轨道交通",
        subList: [{id: 1, name: "轨道交通信号"}]
      },
      {
        id: 4,
        name: "烟草",
        subList: [{id: 1, name: "烟草行业"}, {id: 2, name: "制丝系统"}]
      },
      {
        id: 5,
        name: "市政",
        subList: [
          {id:1,name:"水务行业"},{id:2,name:"燃气行业"}]
      },
      {
        id: 6,
        name: "智能制造",
        subList: [{id: 1, name: "智能制造"}, {id: 2, name: "汽车制造"}, {id: 3, name: "3C制造"}, {id: 4, name: "装备制造"}]
      },
      {
        id: 7,
        name: "煤矿",
        subList: [{id: 1, name: "煤矿行业"}, {id: 2, name: "智慧矿山"}]
      },
      {
        id: 8,
        name: "教育",
        subList: [{id: 1, name: "教育行业等保"},{id: 2, name: "实训基地"}]
      }
    ],
    serviceList: [
      {
        id: 1,
        name: "工业安全运维服务",
        subList: [
          {id: 1, name: "安全预警与监测服务"},
          {id: 2, name: "安全加固服务"},
          {id: 3, name: "重要时期安全保障服务"},
          {id: 4, name: "网络安全托管服务"},
          {id: 5, name: "资产终端安全管理服务"}
        ]
      },
      {
        id: 2,
        name: "工业安全应急服务",
        subList: [
          {id: 1, name: "攻防实战演习服务"},
          {id: 2, name: "应急响应服务"},
          {id: 3, name: "溯源与取证服务"},
          {id: 4, name: "应急演练服务"}
        ]
      },
      {
        id: 3,
        name: "工业安全评估服务",
        subList: [
          {id: 1, name: "工业网络安全评估服务"},
          {id: 2, name: "风险评估服务"},
          {id: 3, name: "渗透测试服务"},
          {id: 4, name: "漏洞扫描服务"},
          {id: 5, name: "基线核查服务"},
          {id: 6, name: "安全审计服务"}
        ]
      },
      {
        id: 4,
        name: "工业安全咨询规划服务",
        subList: [
          {id:1,name:"等级保护咨询服务"},
          {id:2,name:"安全建设规划服务"},
          {id:3,name:"安全管理咨询服务"}
        ]
      },
      {
        id: 5,
        name: "工业安全培训服务",
        subList: [
          {id: 1, name: "工业网络安全培训"},
          {id: 2, name: "安全运营技术培训"},
          {id: 3, name: "攻防实战培训"},
          {id: 4, name: "威胁分析培训"}
        ]
      }],
    productionList: [
      {
        id: 1,
        name: "三级联动",
        subList: [
          {id: 1, name: "双湃工业威胁探测器系统"},
          {id: 2, name: "双湃工业安全统一管理与态势分析系统"},
          {id: 3, name: "双湃工业互联网威胁监测平台"},
          {id: 4, name: "双湃工业互联网资产扫描器系统"}
        ]
      },
      {
        id: 2,
        name: "工业等级保护",
        subList: [
          {id: 1, name: "双湃工业控制安全防火墙系统"},
          {id: 2, name: "双湃工业安全审计监测系统"},
          {id: 3, name: "双湃工业安全隔离与信息交换系统"},
          {id: 4, name: "双湃工业安全终端防护系统"},
          {id: 5, name: "双湃工业网络可靠运行监测平台"}
        ]
      },
      {
        id: 3,
        name: "数据流通",
        subList: [
          {id: 1, name: "双湃可信数据空间"}
        ]
      }
    ]
  },
  mutations: {
    /**
     * 请求依次存放数组中
     * @param state
     * @param data
     */
    setActiveRoute(state, data) {
      state.activeRoute = data;
    },
    getProductList(state, data){
      state.productList = data;
    }
  }
};

export default menu;
